import React, { useEffect, useState } from "react";
import { DevTool } from "@hookform/devtools";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CircularProgress,
  Modal,
  TextField,
  Typography,
  Avatar,
  Badge,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../comman/SnackBarUI";
import { getBannerAction } from "../../redux/toolkit/banner/getBanner";
import { uplodImageAction } from "../../redux/toolkit/image/uplodImage";
import { updateBannerAction } from "../../redux/toolkit/banner/updateBanner";
import { editSingleAppAction, editSingleAppReducer } from "../../redux/toolkit/publisher/updateApp";
import { getSinglePublisherAction } from "../../redux/toolkit/publisher/publisherDetails";
import { Refresh } from "@mui/icons-material";

// schema
const bannerSchema = yup
  .object()
  .shape({
    reward_type: yup.number().required("Reward Type is required."),
  })
  .required();

const UpdatePublisherApp = ({ state, setState }) => {
  const dispatch = useDispatch();

  const singleApp = useSelector((state) => state.getSingelApp);
  const { data: appData, status, message, loading } = singleApp;

  const [snack, setSnack] = useState(false);

  console.log('singleApp=====================>',singleApp)

  const {
    register,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({ resolver: yupResolver(bannerSchema) });

  // fn
  useEffect(() => {
    let defaultValues = {};
    defaultValues.reward_type = appData.reward_type;
    reset({ ...defaultValues });
  }, [appData]);

  const handleEditApp = async (data) => {
    setState(false);

    let payload = {
      app_id: appData?._id,
      ...data,
    };
    console.log("payload================>",payload)
    // return
    const updateCategoryData = await dispatch(editSingleAppAction(payload));
     
    setSnack(true);
      setTimeout(() => {
      window.location.reload();   // ✅ Refresh page
    }, 1000);

    
  };

  const handleClose = function () {
    setState(false);
  };

  return (
    <>
      <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
        <Box className="modal_box">
          <Card sx={{ width: 400, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Edit App
            </Typography>
            <form onSubmit={handleSubmit(handleEditApp)}>
              <Stack spacing={3}>
                <Stack spacing={3}>
                  {/* Reward Type Dropdown */}
                  <FormControl fullWidth>
                    <InputLabel id="reward-type-label">Reward Type</InputLabel>
                    <Select
                      labelId="reward-type-label"
                      label="Reward Type"
                      defaultValue={appData?.reward_type}
                      {...register("reward_type")}
                      error={!!errors?.reward_type?.message}
                    >
                      <MenuItem value={1}>Non-Redemption</MenuItem>
                      <MenuItem value={2}>Redemption</MenuItem>
                      <MenuItem value={3}>Postback</MenuItem>
                    </Select>
                    {errors?.reward_type?.message && (
                      <FormHelperText error>
                        {errors.reward_type.message}
                      </FormHelperText>
                    )}
                  </FormControl>

                
                </Stack>

              
                <Stack direction="row" spacing={2}>
                  <Button variant="contained" type="submit" disabled={loading}>
                    {loading ? <CircularProgress /> : "Update"}
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>
      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
      <DevTool control={control} />
    </>
  );
};

export default UpdatePublisherApp;
